import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedBox,
  Link,
} from '../../..';

const InvestmentCardViewDetails = ({
  pathAlias,
  pathProps,
  linkText,
  linkType,
}) => {
  return (
    <ExtendedBox
      pt={20}
      px={10}
      position="absolute"
      bottom="20px"
    >
      <Link
        type="L4"
        withActiveStyle={false}
        {...(linkType === 'to' ? { to: pathAlias } : { href: pathAlias })}
        {...pathProps}
      >
        {linkText}
      </Link>
    </ExtendedBox>
  );
};

InvestmentCardViewDetails.propTypes = {
  pathAlias: PropTypes.string,
  pathProps: PropTypes.object,
  linkText: PropTypes.string,
  linkType: PropTypes.string,
};

InvestmentCardViewDetails.defaultProps = {
  pathAlias: '',
  linkText: 'View Details >',
};

export default InvestmentCardViewDetails;
